import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  ScreenNav,
  ShopsSearchForm,
  Messages,
  SearchFormContext,
  errorTypes,
  preloadSteps,
  withRestorableDraft,
  withProgressBar,
} from '~/components';

import { config as envConfig } from 'ENV_CONFIG';
import { appointmentDraftActions, api } from '~/api';
import { getSafety } from '~/utils';

const { NO_SHOP_SEARCH_MADE_ERROR } = errorTypes;

export class Shops extends PureComponent {
  state = {
    context: {
      searchFormTitle: 'Find a shop',
      searchFormInlineErrorMsg: 'Please enter a valid shop name, town or postcode',
      isSearchTermInvalid: false,
    },
    isAjaxCompleted: false,
  };

  componentDidMount() {
    this.setState({
      isAjaxCompleted: true,
    });
    window.scrollTo(0, 0);
  }

  onShopsLoadedHandler = () => {
    this.setState((prevState) => ({
      context: {
        ...prevState.context,
        isSearchTermInvalid: false,
      },
    }));
  };

  render() {
    const { prevPath, landingPageUrl } = this.props;

    const { context, isAjaxCompleted } = this.state;

    return (
      <section data-testid="Shops" data-test-ajax={isAjaxCompleted}>
        <SearchFormContext.Provider value={context}>
          <ShopsSearchForm messages={Messages} onShopsLoadedHandler={this.onShopsLoadedHandler}>
            <Messages forTypes={[NO_SHOP_SEARCH_MADE_ERROR]} />
          </ShopsSearchForm>
        </SearchFormContext.Provider>
        <ScreenNav prevPath={prevPath} externalPrevPath={landingPageUrl} hideNextButton />
      </section>
    );
  }
}

export const mapStateToProps = ({
  shops: { shops },
  appointment: {
    draft: {
      appointmentType: { id: appointmentTypeId },
    },
  },
  services: {
    config: { shopsPrevPath },
  },
}) => ({
  shops,
  prevPath: shopsPrevPath,
  landingPageUrl: getSafety(
    envConfig.services[api.SERVICE_NAME],
    `appointmentTypes.${appointmentTypeId}.landingPageUrl`,
    envConfig.services[api.SERVICE_NAME].landingPageUrl,
  ),
});

const mapDispatchToProps = {
  dispatchUpdateAppointmentType: appointmentDraftActions.updateAppointmentType,
};

export const ConnectedShopsPreloadSteps = preloadSteps(
  withRestorableDraft(connect(mapStateToProps, mapDispatchToProps)(withProgressBar(Shops))),
);

export const ConnectedShops = withRestorableDraft(
  connect(mapStateToProps, mapDispatchToProps)(Shops),
);

Shops.propTypes = {
  prevPath: PropTypes.string,
  landingPageUrl: PropTypes.string.isRequired,
};

Shops.defaultProps = {
  prevPath: '',
};
